import React, { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthShell, IDField, GoogleButton } from "@/components/AuthShell";
import { IDButton } from "@/marketing/brand";
import { toast } from "sonner";

export default function Signup() {
  const { user, loading, register, startEmergentGoogle } = useAuth();
  const navigate = useNavigate();
  const [f, setF] = useState({ name: "", email: "", password: "", confirm: "" });
  const [busy, setBusy] = useState(false);

  if (!loading && user) return <Navigate to="/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    if (!f.name.trim()) return toast.error("Please enter your name.");
    if (f.password.length < 8) return toast.error("Password must be at least 8 characters.");
    if (f.password !== f.confirm) return toast.error("Passwords do not match.");
    setBusy(true);
    try {
      await register(f.name.trim(), f.email.trim(), f.password);
      toast.success("Welcome to Intrinsic Daily.");
      navigate("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not create your account.");
    } finally { setBusy(false); }
  };

  return (
    <AuthShell title="Create your account" subtitle="Begin a calm, beautiful operating rhythm for the life you're becoming."
      footer={<p className="id-sans text-center text-sm text-[var(--id-charcoal)]/60">Already have an account? <Link to="/login" className="text-[var(--id-walnut)] font-medium id-link-underline">Sign in</Link></p>}>
      <GoogleButton onClick={startEmergentGoogle} label="Sign up with Google" />
      <div className="my-6 flex items-center gap-4">
        <div className="h-px flex-1 bg-[var(--id-mist)]" />
        <span className="id-sans text-[11px] uppercase tracking-[0.18em] text-[var(--id-charcoal)]/45">or with email</span>
        <div className="h-px flex-1 bg-[var(--id-mist)]" />
      </div>
      <form onSubmit={submit} className="space-y-4" data-testid="signup-form">
        <IDField label="Full name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} placeholder="Grace Adeyemi" data-testid="signup-name" autoComplete="name" />
        <IDField label="Email" type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} placeholder="you@example.com" data-testid="signup-email" autoComplete="email" />
        <IDField label="Password" type="password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} placeholder="At least 8 characters" data-testid="signup-password" autoComplete="new-password" />
        <IDField label="Confirm password" type="password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} placeholder="Re-enter your password" data-testid="signup-confirm" autoComplete="new-password" />
        <IDButton as="button" type="submit" variant="solid" disabled={busy} className="w-full !py-3.5" testid="signup-submit">{busy ? "Creating…" : "Create account"}</IDButton>
      </form>
      <p className="id-sans mt-5 text-center text-xs text-[var(--id-charcoal)]/45">By creating an account you agree to grow with intention.</p>
    </AuthShell>
  );
}
